const types = {
  LOAD_CLINIC: "LOAD_CLINIC",
};

const module = {
  namespaced: true,
  state: {
    clinic: "",
    inHospital2: [
      "1600045788", // james local
    ],
  },
  actions: {
    async actionLoadClinic({ commit }) {
      commit(types.LOAD_CLINIC);
    },
  },
  mutations: {
    [types.LOAD_CLINIC](state) {
      state.clinic = localStorage.getItem("CLINIC");
    },
  },
  getters: {
    isInHospital2Usable: (state) => {
      // return state.inHospital2.indexOf(state.clinic) === -1;
      return true;
    },
  },
};

export default module;
